import React from 'react';
import Command from './_Command';
import { mdiDeleteOutline } from '@mdi/js';
//import { GlobalVariables } from '../../pdf/GlobalVariables';
import { GlobalDialogs } from '../../pdf/GlobalDialogs';
import i18next from 'i18next';
import AlertModalDialog from '../Layout/Dialogs/AlertModalDialog';
import { ApryseUpdater } from '../../pdf/ApryseUpdater';
import { ApryseSDK } from '../../pdf/ApryseSDK';
import { canEditAnnot } from '../../utils';

export default class DeleteAnnotController extends Command {
    constructor() {
        super({
            Enabled: isEnabled(),
            Key: 'deleteAnnotController',
            Path: mdiDeleteOutline,
            Callback: () => showDeleteDialog(),
        });
    }
}

const showDeleteDialog = () => {
    GlobalDialogs.showDialog(
        i18next.t('deleteAnnotDialog.title', {
            count: ApryseUpdater.selectedAnnotations?.length ?? 0,
        }),
        <AlertModalDialog
            cancelText={i18next.t('deleteAnnotDialog.cancelButtonText')}
            confirmText={i18next.t('deleteAnnotDialog.confirmButtonText')}
            dialogTitle={i18next.t('deleteAnnotDialog.title', {
                count: ApryseUpdater.selectedAnnotations?.length ?? 0,
            })}
            dialogBody={i18next.t('deleteAnnotDialog.subtext', {
                count: ApryseUpdater.selectedAnnotations?.length ?? 0,
            })}
            isActionDisabled={false}
            isOpen={true}
            onConfirm={onConfirmDelete}
            onCancel={GlobalDialogs.closeDialog}
            onClose={GlobalDialogs.closeDialog}
        />,
    );
};

const onConfirmDelete = () => {
    if (!ApryseUpdater.selectedAnnotations?.length) {
        return;
    }
    ApryseSDK.deleteAnnotations(ApryseUpdater.selectedAnnotations);
    GlobalDialogs.closeDialog();
};

const isEnabled = (): boolean => {
    if (!ApryseUpdater.selectedAnnotations?.length || ApryseSDK.textAnnotationEditingContext) {
        return false;
    }
    return ApryseUpdater.selectedAnnotations.every(a => canEditAnnot(a));
};
